/**
  * Bug #503
  * @Author Jithin Kuriakose
  * @Date 19 July 2021
  */
import { DatePicker } from './';
const {RangePicker} = DatePicker;

export default function DateRangePicker({...props}) {
    return (
        <RangePicker {...props}  />
    )
}
